import type { Component } from "svelte";
import RestaurantIcon from '$lib/ui/shared/icons/RestaurantVertical.svelte';
import GroceryIcon from '$lib/ui/shared/icons/GroceryVertical.svelte';
import StoreIcon from '$lib/ui/shared/icons/ShopsVertical.svelte';

export const KEY_VERTICAL = 'vertical';

export enum Vertical {
	Restaurant = 'restaurant',
	Grocery = 'grocery',
	Store = 'store',
}

export const verticals: { title:string, slug:Vertical, icon: Component<any> }[] = [
	{ title: 'Restaurants', slug: Vertical.Restaurant, icon: RestaurantIcon },
	{ title: 'Pick n Pay', slug: Vertical.Grocery, icon: GroceryIcon },
	{ title: 'Shops', slug: Vertical.Store, icon: StoreIcon },
];